import { Launch } from "@mui/icons-material";
import { Autocomplete, IconButton, TextField, Tooltip } from "@mui/material";

import { autoCompleteStyles } from "../../../../cm/Dashboard/FullPages/constant";
import FormField from "../../../../global/FormComponents/field/FormField";

const CasesField = ({
  clientCases,
  selectedCase,
  handleCaseSelect,
  setCaseSearch,
  tooltipTitle,
  goToActionables,
  linkDisabled,
}) => (
  <FormField label="Cases">
    <Autocomplete
      className="w-full"
      disablePortal
      options={clientCases ?? []}
      getOptionLabel={(option) => option?.label ?? ""}
      isOptionEqualToValue={(option, value) => option?.id === value?.id}
      noOptionsText="No Results"
      sx={{
        width: 300,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onChange={handleCaseSelect}
      value={selectedCase ?? null}
      renderOption={(props, option) => (
        <li {...props} id={`${option.id}`} key={`${option.id}`}>
          {option.label}
        </li>
      )}
      renderInput={(params) => (
        <div className="flex w-full content-center">
          <TextField
            {...params}
            sx={autoCompleteStyles}
            onChange={(e) => setCaseSearch(e.target.value)}
          />
          <Tooltip title={tooltipTitle}>
            <IconButton
              size="small"
              onClick={goToActionables}
              disabled={linkDisabled}
              sx={{
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Launch />
            </IconButton>
          </Tooltip>
        </div>
      )}
    />
  </FormField>
);

export default CasesField;
